import { createRouter, createWebHistory } from "vue-router";
import { applyRouteSeo } from '../utils/seo'

// oj
// const UserGroup = () => import()
const NotFound = () => import('../components/NotFound.vue')

// problem
const ProblemList = () => import('../pages/oj/problem/problemList.vue')
const Problem = () => import('../pages/oj/problem/problem.vue')

const ResetPassword = () => import('../pages/oj/user/ResetPassword.vue')
const Login = () => import('../pages/oj/user/Login.vue')
const Register = () => import('../pages/oj/user/Register.vue')

const CloudIDE = () => import('../pages/oj/CloudIDE.vue')

// activity const UserGroup = () => import()
const ActivityList = () => import('../pages/oj/activity/ActivityList.vue')
const ActivityContent = () => import('../pages/oj/activity/Activity.vue')
const ActivityWXPay = () => import('../pages/oj/activity/ActivityWXPay.vue')
const ActivityProblems = () => import('../pages/oj/activity/ActivityProblems.vue')
const ActivityVideoList = () => import('../pages/oj/activity/ActivityVideoList.vue')
const ActivityResource = () => import('../pages/oj/activity/ActivityResource.vue')
const ActivityCodeAdd = () => import('../pages/oj/activity/ActivityCodeAdd.vue')
const ActivityCodeContentEdit = () => import('../pages/oj/activity/ActivityCodeContentEdit.vue')
const ActivityProblemCodeContentEdit = () => import('../pages/oj/activity/ActivityProblemCodeContentEdit.vue')
const ActivityProblemContent = () => import('../pages/oj/activity/ActivityProblemContent.vue')
const ActivityRank = () => import('../pages/oj/activity/ActivityRank.vue')
const ActivityCheckinFeed = () => import('../pages/oj/activity/ActivityCheckinFeed.vue')
const ActivitySubmissionList = () => import('../pages/oj/activity/ActivitySubmissionList.vue')
const ActivityCodeContent = () => import('../pages/oj/activity/ActivityCodeContent.vue')
const ActivityProblemCodeContent = () => import('../pages/oj/activity/ActivityProblemCodeContent.vue')
const ActivitySubmissionCodeContent = () => import('../pages/oj/activity/ActivitySubmissionCodeContent.vue')
const SubmissionList = () => import('../pages/oj/problem/SubmissionList.vue')
const SubmissionListAdmin = () => import('../pages/oj/problem/SubmissionListAdmin.vue')
const SubmissionContent = () => import('../pages/oj/problem/SubmissionContent.vue')
const AdminIndex = () => import('../pages/admin/Index.vue')


const Index = () => import('../pages/oj/index.vue')
const UserInfoPage = () => import('../pages/oj/user/UserSpace.vue')
const Userspace = () => import('../pages/oj/user/UserSpace2.vue')

const Test = () => import('../pages/oj/Test.vue')
const NewAce = () => import('../pages/oj/NewAce.vue')
const CalendarVue = () => import('../pages/oj/Calendar.vue')
const ProblemVideoList = () => import('../pages/oj/problem/ProblemVideoList.vue')
const SelectionProblem = () => import('../pages/oj/problem/SelectionProblem.vue')

const PaperProblem = () => import('../pages/oj/problem/PaperProblem.vue')
const ProblemSolutionList = () => import('../pages/oj/problem/ProblemSolutionList.vue')
const ProblemSolutionContent = () => import('../pages/oj/problem/ProblemSolutionContent.vue')
const ProblemSolutionFavorite = () => import('../pages/oj/problem/ProblemSolutionFavorite.vue')
const AddProblemSolution = () => import('../pages/oj/problem/AddProblemSolution.vue')
const AddProblemSolutionExternal = () => import('../pages/oj/problem/AddProblemSolutionExternal.vue')
const EditProblemSolution = () => import('../pages/oj/problem/EditProblemSolution.vue')
const NewBlog = () => import('../pages/oj/blog/NewBlog.vue')

const BlogList = () => import('../pages/oj/blog/BlogList.vue')
const Blog = () => import('../pages/oj/blog/Blog.vue')
const EditBlog = () => import('../pages/oj/blog/EditBlog.vue')
const KnowledgeShare = () => import('../pages/oj/community/KnowledgeShare.vue')
const DiscussionHub = () => import('../pages/oj/community/DiscussionHub.vue')
const ExamPackList = () => import('../pages/oj/exam/ExamPackList.vue')
const ExamPackDetail = () => import('../pages/oj/exam/ExamPackDetail.vue')

// training
const TrainingDetail = () => import("../pages/oj/training/TrainingDetail.vue")
const TrainingCreate = () => import("../pages/oj/training/TrainingCreate.vue")
const TrainingProblemList = () => import("../pages/oj/training/children/TrainingProblemList.vue")
const TrainingRank = () => import("../pages/oj/training/children/TrainingRank.vue")
const TrainingEdit = () => import("../pages/oj/training/children/TrainingEdit.vue")
const TrainingList = () => import("../pages/oj/training/TrainingList.vue")

// contest
const ContestList = () => import("../pages/oj/contest/ContestList.vue")
const ContestAdd = () => import("../pages/oj/contest/ContestAdd.vue")
const ContestDetail = () => import("../pages/oj/contest/ContestDetail.vue")
const ContestRank = () => import("../pages/oj/contest/ContestRank.vue")
const ContestProblemList = () => import("../pages/oj/contest/ContestProblemList.vue")
const ContestProblem = () => import("../pages/oj/contest/ContestProblem.vue")

// online ide
const OnlineIDE = () => import("../pages/oj/onlineide/OnlineIDE.vue")

// Group
const GroupHome = () => import("../pages/oj/group/GroupHome.vue")
const GroupMemberList = () => import("../pages/oj/group/children/GroupMemberList.vue")
const GroupTrainingList = () => import("../pages/oj/group/children/GroupTrainingList.vue")
const GroupHomeworkList = () => import("../pages/oj/group/children/GroupHomeworkList.vue")
const GroupContestList = () => import("../pages/oj/group/children/GroupContestList.vue")

// Notice
const Notice = () => import("../pages/oj/notice/Notice.vue")
const UserNotice = () => import("../pages/oj/notice/children/UserNotice.vue")

// User
const UserGroup = () => import('../pages/oj/user/children/UserGroup.vue')
const UserGroupCreate = () => import('../pages/oj/user/UserGroupCreate.vue')
const UserInfo = () => import('../pages/oj/user/children/UserInfo.vue')
const UserTraining = () => import('../pages/oj/user/children/UserTraining.vue')
const UserFavorite = () => import('../pages/oj/user/children/UserFavorite.vue')

// admin const UserGroup = () => import()
const AddProblem = () => import('../pages/admin/problem/AddProblem.vue')
const AddSelectionProblem = () => import('../pages/admin/problem/AddSelectionProblem.vue')
const SelectionProblems = () => import('../pages/admin/problem/SelectionProblems.vue')
const UpdateSelectionProblem = () => import('../pages/admin/problem/UpdateSelectionProblem.vue')

const AdminProblemList = () => import('../pages/admin/problem/Problems.vue')
const UrlProblems = () => import('../pages/admin/problem/UrlProblems.vue')
const AddUrlProblem = () => import('../pages/admin/problem/AddUrlProblem.vue')

const UpdateProblem = () => import('../pages/admin/problem/UpdateProblem.vue')
const UpdateUrlProblem = () => import('../pages/admin/problem/UpdateUrlProblem.vue')
const TypeApp = () => import('../pages/oj/Type.vue')
const AdminImage = () => import('../pages/admin/media/images.vue')
const AdminUser = () => import('../pages/admin/general/User.vue')
const PruneTestCase = () => import('../pages/admin/general/PruneTestCase.vue')
const AdminAnalytics = () => import('../pages/admin/general/AdminAnalytics.vue')
const AdminJudgeLanguageConfig = () => import('../pages/admin/general/JudgeLanguageConfig.vue')
const AdminSystemMonitor = () => import('../pages/admin/general/SystemMonitor.vue')
const AdminActivityList = () => import('../pages/admin/activity/AdminActivityList.vue')
const AdminAddActivity = () => import('../pages/admin/activity/AdminAddActivity.vue')
const AdminEditActivity = () => import('../pages/admin/activity/AdminEditActivity.vue')
const TagList = () => import('../pages/admin/general/TagList.vue')

const FPSImport = () => import('../pages/admin/problem/FPSImport.vue')
const AdminAddContest = () => import('../pages/admin/contest/AdminAddContest.vue')
const AdminContestList = () => import('../pages/admin/contest/AdminContestList.vue')
const AdminEditContest = () => import('../pages/admin/contest/AdminEditContest.vue')
const AdminExamPack = () => import('../pages/admin/exam/AdminExamPack.vue')

const Schedule = () => import('../pages/oj/schedule.vue')
const AddSchedule = () => import('../pages/admin/general/AddSchedule.vue')
const IndexCarousel = () => import('../pages/admin/general/IndexCarousel.vue')

const routes = [
    { path: '/', component: Index, meta: { title: 'CodeAC' } },
    { path: '', component: Index, meta: { title: 'CodeAC' } },
    { path: '/activity', name:"ActivityList", component: ActivityList, meta: { title: '在线课程 - CodeAC' } },
    {
        path: '/activity/:activityId',
        name: "ActivityDetail",
        component: ActivityContent,
        meta: { title: '课程 - CodeAC' },
        children: [
            { name: 'ActivityProblemList', path: 'problems', component: ActivityProblems, meta: { title: 'Activity Problem' } },
            { name: "ActivityCheckinFeed", path: 'feed', component: ActivityCheckinFeed, meta: { title: '课程动态 - CodeAC' } },
            { name: "ActivityRank", path: 'rank', component: ActivityRank, meta: { title: '课程 - CodeAC' } },
            { name: "ActivitySubmissionList", path: 'user/:userId/submissions', component: ActivitySubmissionList, meta: { title: '课程 - CodeAC' },
                children: [
                    {
                        name: 'ActivitySubmissionCodeContent',
                        path: 'problem/:problemId/content/code/:codeId/content',
                        component: ActivitySubmissionCodeContent,
                        meta: { title: 'Activity Submission Code' },
                    },
                ]},
        ]
    },
    // { path: '/activity/problems/:id', component: ActivityProblems, meta: {title: '课程 - CodeAC'}},
    { path: '/activity/problems/:id', component: ActivityContent, meta: { title: '课程 - CodeAC' } },
    { path: '/activity/videos/:id', component: ActivityVideoList, meta: { title: '课程 - CodeAC' } },
    { path: '/activity/resources/:id', component: ActivityResource, meta: { title: '课程 - CodeAC' } },
    // { path: '/activity/rank/:id', component: ActivityRank, meta: { title: '课程 - CodeAC' } },
    { path: '/activity/:activityId/code/:problemId', name: "ActivityCodeAdd", component: ActivityCodeAdd, meta: { title: '课程 - CodeAC' } },
    { path: '/activity/:id/code/:problem_id/code_content/:code_id', component: ActivityContent, meta: { title: '课程 - CodeAC' } },
    { path: '/activity/:act_id/code/:problem_id/content/:id/edit', component: ActivityCodeContentEdit, meta: { title: '课程 - CodeAC' } },
    {
        path: '/activity/:activityId/problem/content/:id',
        name: "ActivityProblemContent",
        component: ActivityProblemContent,
        meta: { title: '课程 - CodeAC' },
        children: [
            {
                name: 'ActivityProblemCode',
                path: 'code/:codeId',
                component: ActivityCodeContent,
                meta: { title: 'Activity Problem Code' },
                children: [
                    { name: 'ActivityCodeContentEdit', path: 'edit', component: ActivityCodeContentEdit, meta: { title: 'Activity Problem Code Edit' } },
                ]
            },
        ]
    },
    {
        name: 'ActivityProblemCodeContent',
        path: '/activity/:activityId/problem/:problemId/content/code/:codeId/content',
        component: ActivityProblemCodeContent,
        meta: { title: 'Activity Problem Code' },
        children: [
            { name: 'ActivityProblemCodeContentEdit', path: 'edit', component: ActivityProblemCodeContentEdit, meta: { title: 'Activity Problem Code Edit' } },
        ]
    },
    { path: '/ide', component: CloudIDE, meta: { title: '云IDE | CodeAC' } },
    { path: '/problem', component: ProblemList, meta: { title: '题库 - CodeAC', } },
    {
        path: '/problem/:problemId',
        component: Problem,
        meta: { title: 'Problem - CodeAC', },
        name: "Problem",
        children: [
            {   name: 'SubmissionList', path: 'submission', component: SubmissionList, meta: { title: '提交记录' },
                children: [
                    { name: 'SubmissionContent', path: ':submissionId', component: SubmissionContent, meta: { title: 'SubmissionContent' }},
                ]
            },
            { name: 'SubmissionListAll', path: 'submission/all', component: SubmissionListAdmin, meta: { title: 'Submission All' },children: [
                { name: 'AllSubmissionContent', path: ':submissionId', component: SubmissionContent, meta: { title: 'SubmissionContent' }},
            ]},
            { name: 'ProblemSolutionList', path: 'solution', component: ProblemSolutionList, meta: { title: 'Submission All' },children: []},
        ]
    },
    // { path: '/problem/submission/:id', component: SubmissionList},
    { path: '/problem/video/:id', component: ProblemVideoList },
    { path: '/problem/selection/:id', component: SelectionProblem },
    { path: '/problemset/:id', component: PaperProblem },
    { path: '/problem/:pid/solution/content/:id', name: "ProblemSolutionContent",component: ProblemSolutionContent },
    { path: '/problem/:id/solution/add', name: "AddProblemSolution", component: AddProblemSolution },
    { path: '/problem/:pid/solution/add/external', name: "AddProblemSolutionExternal", component: AddProblemSolutionExternal },
    { path: '/problem/:pid/solution/:id/edit', name: "EditProblemSolution", component: EditProblemSolution },
    { path: '/problem/solution/:id', name: "ProblemSolutionFavorite", component: ProblemSolutionFavorite },
    // { path: '/problem/submission/:pid/content/:sid', component: SubmissionContent},
    { path: '/login', component: Login, meta: { title: '登录 - CodeAC' } },
    { path: '/reset/:token', component: ResetPassword },
    { path: '/user', name: "User", component: UserInfoPage, children: [
        { path: 'group', name: "UserGroup", component: UserGroup },
        { path: 'info', name: "UserInfo", component: UserInfo },
        { path: 'training', name: "UserTraining", component: UserTraining },
        { path: 'favorite', name: "UserFavorite", component: UserFavorite },
    ] , meta: {requiresLogin: true}},
    { path: '/user/group/create', name: "UserGroupCreate", component: UserGroupCreate },
    { path: '/user/space', component: Userspace },
    { path: '/user/space2', redirect: '/user/space' },
    { path: '/register', component: Register, meta: { title: '注册 - CodeAC' } },
    { path: '/activity/:id/wxpay', component: ActivityWXPay },
    { path: '/calendar', component: CalendarVue },
    { path: '/new_ide', component: NewAce },
    { path: '/typing', component: TypeApp },
    { path: '/schedule', component: Schedule },
    { path: '/knowledge', component: KnowledgeShare, meta: { title: "知识分享 - CodeAC" } },
    { path: '/discussion/:questionId?', name: "DiscussionHub", component: DiscussionHub, meta: { title: "问答区 - CodeAC" } },
    { path: '/exam-pack', name: 'ExamPackList', component: ExamPackList, meta: { title: '考试题单 - CodeAC' } },
    { path: '/exam-pack/:id', name: 'ExamPackDetail', component: ExamPackDetail, meta: { title: '考试作答 - CodeAC' } },
    { path: '/blog/new', component: NewBlog, meta: { title: "写文章 - CodeAC" } },
    { path: '/blog', component: BlogList, meta: { title: "文章列表 - CodeAC" } },
    { path: '/blog/:id', component: Blog, meta: { title: "文章 - CodeAC" } },
    { path: '/blog/edit/:id', component: EditBlog, meta: { title: "编辑文章 - CodeAC" } },
    // training
    { path: '/training', component: TrainingList, meta: { title: "题单列表 - CodeAC" } },
    { path: '/training/:id', name: "TrainingDetail", component: TrainingDetail, meta: { title: "题单" }, children:[
        {   path: 'problem', name: 'TrainingProblemList', component: TrainingProblemList, meta: { title: '题目列表 - CodeAC' }},
        {   path: 'edit', name: 'TrainingEdit', component: TrainingEdit, meta: { title: '题单编辑 - CodeAC' }},
        {   path: 'rank', name: 'TrainingRank', component: TrainingRank, meta: { title: '题单排行榜 - CodeAC' }},
    ] },
    { path: '/training/new', name:"TrainingCreate", component: TrainingCreate, meta: { title: "新建题单" } },
    // contest
    { path: '/contest', component: ContestList, meta: { title: "比赛列表" } },
    { path: '/contest/add', component: ContestAdd, name: "ContestAdd", meta: { title: "添加比赛" } },
    { 
        path: '/contest/:contestId',
        name: "ContestDetail",
        component: ContestDetail,
        meta: { title: "比赛" },
        children: [
            { name: 'ContestProblemList', path: 'problems', component: ContestProblemList, meta: { title: '题目列表' } },
            { name: 'ContestRank', path: 'rank', component: ContestRank, meta: { title: '比赛排名' } },
        ]
    },
    { name: 'ContestProblem', path: '/contest/:contestId/problem/:problemId', component: ContestProblem, meta: { title: '题目' } },
    // online ide
    { path: '/onlineide', component: OnlineIDE, meta: { title: 'Online IDE - CodeAC' } },
    // group
    { path: '/group/:groupId', name:"GroupHome", component: GroupHome, meta: { title: '团队主页 - CodeAC' },
        children: [
            {   path: 'member', name: 'GroupMemberList', component: GroupMemberList, meta: { title: '团队成员 - CodeAC' }},
            {   path: 'training', name: 'GroupTrainingList', component: GroupTrainingList, meta: { title: '团队题单 - CodeAC' }},
            {   path: 'homework', name: 'GroupHomeworkList', component: GroupHomeworkList, meta: { title: '团队作业 - CodeAC' }},
            {   path: 'contest', name: 'GroupContestList', component: GroupContestList, meta: { title: '团队比赛 - CodeAC' }},
        ] },

    // notice
    { path: '/message', component: Notice, meta: { title: '消息中心 - CodeAC' }, children:[
        {
            path: 'mine', name: 'UserNotice', component: UserNotice, meta: { title: '我的消息' }
        },
    ] },

    // Test
    { path: '/test', component: Test, meta: { title: 'Test - CodeAC' } },
    // Admin
    {
        path: '/admin',
        name: "AdminIndex",
        component: AdminIndex,
        meta: { requiresAuth: true, title: 'Admin - CodeAC' },
        children: [
            // problem
            { path: 'addProblem', name: "AddProblem", component: AddProblem, meta: { requiresAuth: true, title: 'Admin AddProblem - CodeAC' } },
            { path: 'addUrlProblem', component: AddUrlProblem, meta: { requiresAuth: true, title: 'Admin AddUrlProblem - CodeAC' } },
            { path: 'problems', name: "AdminProblemList", component: AdminProblemList, meta: { requiresAuth: true } },
            { path: 'urlproblems', component: UrlProblems, meta: { requiresAuth: true } },
            { name: "EditProblem", path: 'problem/:problemId/edit', component: UpdateProblem, meta: { requiresAuth: true, title: 'Admin Edit Problem - CodeAC' } },
            { path: 'fps/import', name: "FPSImport", component: FPSImport, meta: { requiresAuth: true } },
            { path: 'user', name: "AdminUser", component: AdminUser, meta: { requiresAuth: true } },
            { path: 'tag', name: "AdminTagList", component: TagList, meta: { requiresAuth: true, title: 'Admin Tag - CodeAC' } },
            { path: 'analytics', name: 'AdminAnalytics', component: AdminAnalytics, meta: { requiresAuth: true, title: '运营数据分析 - CodeAC' } },
            { path: 'prune_test_case', name: 'AdminPruneTestCase', component: PruneTestCase, meta: { requiresAuth: true, title: '测试数据清理 - CodeAC' } },
            { path: 'schedule', name: "AdminAddSchedule", component: AddSchedule, meta: { requiresAuth: true, title: 'Admin AddSchedule - CodeAC' } },
            { path: 'carousel', name: "AdminIndexCarousel", component: IndexCarousel, meta: { requiresAuth: true, title: 'IndexCarousel - CodeAC' } },
            { path: 'judge/language-config', name: "AdminJudgeLanguageConfig", component: AdminJudgeLanguageConfig, meta: { requiresAuth: true, title: '判题语言配置 - CodeAC' } },
            { path: 'judge/system-monitor', name: "AdminSystemMonitor", component: AdminSystemMonitor, meta: { requiresAuth: true, title: '系统监控 - CodeAC' } },
            { path: 'exam-pack', name: "AdminExamPack", component: AdminExamPack, meta: { requiresAuth: true, title: '考试题单管理 - CodeAC' } },

            // activity
            { name: 'AdminActivityList', path: 'activity', component: AdminActivityList, meta: { requiresAuth: true, title: 'Admin Activity' } },
            { name: 'AdminAddActivity', path: 'add_activity', component: AdminAddActivity, meta: { requiresAuth: true, title: 'Admin AddActivity' } },
            { name: "AdminEditActivity", path: 'activity/:activityId/edit', component: AdminEditActivity, meta: { requiresAuth: true } },

            // contest
            { name: 'AdminAddContest', path: 'addContest', component: AdminAddContest, meta: { requiresAuth: true, title: 'Admin AddContest' } },
            { name: 'AdminContestList', path: 'contest', component: AdminContestList, meta: { requiresAuth: true, title: 'Admin ContestList' } },
            { name: 'AdminEditContest', path: 'contest/:contestId/edit', component: AdminEditContest, meta: { requiresAuth: true, title: 'Admin EditContest' } },
        ]
    },
    { path: '/admin/AddSelectionProblem', component: AddSelectionProblem, meta: { requiresAuth: true, title: 'Admin AddSelectionProblem - CodeAC' } },
    { path: '/admin/SelectionProblems', component: SelectionProblems, meta: { requiresAuth: true, title: 'Admin AddSelectionProblem - CodeAC' } },
    { path: '/admin/update/selection/problem/:id', component: UpdateSelectionProblem, meta: { requiresAuth: true, title: 'Admin AddSelectionProblem - CodeAC' } },
    // {path: '/admin/problems', component: Problems, meta: {requiresAuth:true}},
    // {path: '/admin/fps/import', component: FPSImport, meta: {requiresAuth:true}},
    // {path: '/admin/update/problem/:id', component: UpdateProblem, meta: {requiresAuth:true, title: 'Admin Edit Problem - CodeAC'}},
    { path: '/admin/update/url/problem/:id', component: UpdateUrlProblem, meta: { requiresAuth: true, title: 'Admin Edit UrlProblem - CodeAC' } },
    { path: '/admin/images', component: AdminImage, meta: { requiresAuth: true } },
    // {path: '/admin/user', component: AdminUser, meta: {requiresAuth:true}},
    // {path: '/admin/activity', component: AdminActivityList, meta: {requiresAuth:true, title: 'Admin Activity - CodeAC'}},
    // {path: '/admin/activity/:id/edit', component: AdminEditActivity, meta: {requiresAuth:true}},
    // {path: '/admin/tag', component: TagList, meta: {requiresAuth:true, title: 'Admin Tag - CodeAC'}},
    { path: '/404', component: NotFound, meta: { title: '404 | CodeAC' } },
    { path: '/:pathMatch(.*)', redirect: "/404" }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

const syncAdminTheme = (path) => {
    if (typeof document === 'undefined') {
        return
    }
    const isAdminRoute = path.startsWith('/admin')
    document.body.classList.toggle('admin-theme', isAdminRoute)
}

if (typeof window !== 'undefined') {
    syncAdminTheme(window.location.pathname)
}

router.beforeEach((to, from, next) => {
    syncAdminTheme(to.path)
    if (to.meta.requiresAuth) {
        // window.__CODEAC_LOGGER__?.debug(JSON.parse(localStorage.getItem('CodeAC_userInfo')));
        if (localStorage.getItem('CodeAC_userInfo') == null
            || JSON.parse(localStorage.getItem('CodeAC_userInfo')).isSuperAdmin == false)
        // || JSON.parse(localStorage.getItem('CodeAC_userInfo')).isAdmin != 2) 
        {
            return next({ path: '/404' })
        }
    }
    if (to.meta.requiresLogin) {
        // window.__CODEAC_LOGGER__?.debug(JSON.parse(localStorage.getItem('CodeAC_userInfo')));
        if (!!localStorage.getItem('CodeAC_token') == false)
        // || JSON.parse(localStorage.getItem('CodeAC_userInfo')).isAdmin != 2) 
        {
            return next({ path: '/404' })
        }
    }
    
    next()
})

router.afterEach((to) => {
    applyRouteSeo(to)
})

if (typeof window !== 'undefined') {
    applyRouteSeo(router.currentRoute.value)
}

export default router
